module.exports = __webpack_public_path__ + "static/media/randomBtnSFX.d4779fce.mp3";